import { Component } from '@angular/core';

@Component({
    selector: 'app-context-list',
    templateUrl: './context-list.component.html',
    styleUrls: ['./context-list.component.scss'],
})
export class ContextListComponent {}
